/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Totalattempts1Inputs */

const zh_learn_totalattempts1 = /** @type {(inputs: Learn_Totalattempts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总作答次数`)
};

const en_learn_totalattempts1 = /** @type {(inputs: Learn_Totalattempts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total attempts`)
};

const es_learn_totalattempts1 = /** @type {(inputs: Learn_Totalattempts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intentos totales`)
};

/**
* | output |
* | --- |
* | "Total attempts" |
*
* @param {Learn_Totalattempts1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_totalattempts1 = /** @type {((inputs?: Learn_Totalattempts1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Totalattempts1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_totalattempts1(inputs)
	if (locale === "en") return en_learn_totalattempts1(inputs)
	return es_learn_totalattempts1(inputs)
});
export { learn_totalattempts1 as "learn_totalAttempts" }